import { useRef } from 'react';

import { useIsOverflowing } from '@shared/hooks';

export const useIsOverflowingFields = () => {
    const amountRef = useRef(null);
    const unitRef = useRef(null);
    const orderPositionNameRef = useRef(null);
    const { isOverflowing: isAmountOverflowing } = useIsOverflowing({ elRef: amountRef });
    const { isOverflowing } = useIsOverflowing({ elRef: orderPositionNameRef });
    const { isOverflowing: isUnitOverflowing } = useIsOverflowing({ elRef: unitRef });

    return {
        unitRef,
        amountRef,
        orderPositionNameRef,
        isAmountOverflowing,
        isOverflowing,
        isUnitOverflowing,
    };
};
